// Small, dependency-free helpers for building SEO metadata (canonical URLs,
// structured data). Kept framework-agnostic so it can be used both at build
// time (generators) and in components.

export const siteUrl = String(process.env.SITE_URL || '').replace(/\/$/, '');

/**
 * Build an absolute URL from a path or slug.
 * - Leaves already-absolute URLs (http/https) untouched.
 * - Strips a leading slash from the path.
 */
export const absoluteUrl = (path?: string): string => {
	if (!path) return siteUrl;
	if (/^https?:\/\//.test(path)) return path;
	return `${siteUrl}/${String(path).replace(/^\//, '')}`;
};

/**
 * Canonical absolute URL for a page: absolute, with any trailing slash removed
 * so it matches how the site serves URLs and how peer language sites reference
 * it (`…/slug`, no trailing slash). The site root collapses to the bare siteUrl.
 */
export const canonicalUrl = (pathname?: string): string => absoluteUrl(String(pathname || '').replace(/\/+$/, ''));
